import { onSnapshot, query, where, orderBy, limit } from 'firebase/firestore';
import { RankListRequestRef, ScoringRequest } from '../../firebase/collections';

// Action Types
export const FETCH_RANK_REQUEST = 'FETCH_RANK_REQUEST';
export const FETCH_RANK_SUCCESS = 'FETCH_RANK_SUCCESS';
export const FETCH_RANK_FAILURE = 'FETCH_RANK_FAILURE';
export const CLEAR_RANK_DATA = 'CLEAR_RANK_DATA';

export const FETCH_ON_AIR_REQUEST = 'FETCH_ON_AIR_REQUEST';
export const FETCH_ON_AIR_SUCCESS = 'FETCH_ON_AIR_SUCCESS';
export const FETCH_ON_AIR_FAILURE = 'FETCH_ON_AIR_FAILURE';
export const CLEAR_ON_AIR_DATA = 'CLEAR_ON_AIR_DATA';

// Thunks
const thirtyMinutesAgo = new Date();
thirtyMinutesAgo.setMinutes(thirtyMinutesAgo.getMinutes() - 30);

export const subscribeToTempRank = (showID) => (dispatch) => {
    dispatch({ type: FETCH_RANK_REQUEST });
    try {
        const q = query(
            RankListRequestRef,
            where("ShowId", "==", showID),
            where("TimeStamp", ">=", thirtyMinutesAgo),
            orderBy('TimeStamp', 'desc'),
            limit(1)
        );

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const data = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data(),
            }));

            dispatch({ type: FETCH_RANK_SUCCESS, payload: data });
        }, (error) => {
            console.error("Firestore subscription error:", error);
            dispatch({ type: FETCH_RANK_FAILURE, payload: error.message });
        });

        return unsubscribe;

    } catch (error) {
        console.error("Error setting up subscription:", error);
        dispatch({ type: FETCH_RANK_FAILURE, payload: error.message });
    }
};

export const subscribeToHorseOnAir = (showID) => (dispatch) => {
    dispatch({ type: FETCH_ON_AIR_REQUEST });
    try {
        const q = query(
            ScoringRequest,
            where("ShowId", "==", showID),
            where("TimeStamp", ">=", thirtyMinutesAgo),
            orderBy('TimeStamp', 'desc'),
            limit(1)
        );

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const data = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data(),
            }));

            dispatch({ type: FETCH_ON_AIR_SUCCESS, payload: data });
        }, (error) => {
            console.error("Firestore subscription error:", error);
            dispatch({ type: FETCH_ON_AIR_FAILURE, payload: error.message });
        });

        return unsubscribe;

    } catch (error) {
        console.error("Error setting up subscription:", error);
        dispatch({ type: FETCH_ON_AIR_FAILURE, payload: error.message });
    }
};

export const clearRankData = () => ({ type: CLEAR_RANK_DATA });
export const clearOnAirData = () => ({ type: CLEAR_ON_AIR_DATA });
